// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1j2Ek","buttons":"Footer_buttons__1LZkK"};